import React, { useEffect, useRef, useState } from 'react';
import { describeError } from '../api/client.js';
import { getEnrollmentStatus } from '../api/endpoints.js';
import { AuthScene } from '../components/AuthScene.js';

export function PendingPage({
  code,
  onApproved,
  onUsePassword,
}: {
  code: string;
  onApproved: () => void;
  /** Показать вместо ожидания форму входа — если хотят войти под своим логином. */
  onUsePassword?: () => void;
}): React.JSX.Element {
  const [message, setMessage] = useState('Ожидание одобрения администратора…');
  // Обработчик держим в ссылке: родитель передаёт новую функцию на каждой
  // своей перерисовке, и с ним в зависимостях опрос перезапускался бы каждый
  // раз — запросы шли парами, а «одобрено» срабатывало дважды.
  const approved = useRef(onApproved);
  approved.current = onApproved;
  useEffect(() => {
    let active = true;
    const poll = async (): Promise<void> => {
      try {
        const result = await getEnrollmentStatus(code);
        if (!active) return;
        setMessage(result.message);
        if (result.status === 'approved') {
          // Один раз: дальше страница уходит, и второй ответ ей уже не нужен.
          active = false;
          approved.current();
        }
      } catch (error) { if (active) setMessage(describeError(error)); }
    };
    void poll();
    const timer = window.setInterval(() => void poll(), 5000);
    return () => { active = false; window.clearInterval(timer); };
  }, [code]);
  return (
    <AuthScene>
      <h1>Устройство ожидает доступа</h1>
      <p className="auth-lead" role="status">{message}</p>
      <div className="enrollment-code">{code}</div>
      <p className="auth-note">Передайте этот код администратору. После одобрения страница обновится автоматически.</p>
      {onUsePassword !== undefined && (
        <p className="auth-note">
          <button type="button" className="auth-inline-link" onClick={onUsePassword}>
            Войти с логином и паролем
          </button>
        </p>
      )}
    </AuthScene>
  );
}
